import { TimePeriodType } from './components/AddGoalModal/components/TimePeriod';
export const generateTimeOptions = (
  years: Number[],
  timePeriods: TimePeriodType[]
) => {
  return years.flatMap((year) =>
    timePeriods.map((timePeriod: { label: string; shortLabel: string }) => ({
      label: `${timePeriod.shortLabel} ${year}`,
      value: { timePeriod: timePeriod.shortLabel, year: String(year) },
    }))
  );
};
